export const LocalContextKeys = Object.freeze({
  OBJECT_ACCESSOR: "OBJECT_ACCESSOR",
});
